import { render, staticRenderFns } from "./ShoppingCartIcon.vue?vue&type=template&id=02913b17&"
import script from "./ShoppingCartIcon.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports